const init = () => {
    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf())
        date.setDate(date.getDate() + days)
        return date
    }

    Date.prototype.addWeeks = function(weeks) {
        var date = new Date(this.valueOf())
        date.setDate(date.getDate() + weeks * 7)
        return date
    }

    Date.prototype.addMonths = function(months) {
        var date = new Date(this.valueOf())
        return new Date(date.setMonth(date.getMonth() + months));
    }
}


export default {
    init,
}